import { defineMessages } from 'react-intl'

const scope =
  'procurify.platform.globalSearch.useFormatGlobalSearchResultTypeLabel'

export default defineMessages({
  orderRequestLabel: {
    id: `${scope}.orderRequestLabel`,
    defaultMessage: 'Order request',
  },
  expenseRequestLabel: {
    id: `${scope}.expenseRequestLabel`,
    defaultMessage: 'Expense request',
  },
  travelRequestLabel: {
    id: `${scope}.travelRequestLabel`,
    defaultMessage: 'Travel request',
  },
  purchaseOrderLabel: {
    id: `${scope}.purchaseOrderLabel`,
    defaultMessage: 'Purchase order',
  },
  billLabel: {
    id: `${scope}.billLabel`,
    defaultMessage: 'Bill',
  },
  paymentLabel: {
    id: `${scope}.paymentLabel`,
    defaultMessage: 'Payment',
  },
})
